// Single definition of "what a city looks like in a URL".
//
// City values reach the app from three sources with three conventions: the URL
// path (whatever casing the visitor typed or an external site linked), the
// `location` cookie (already a slug), and the events API's venue record, which
// carries the display form — "Ahmedabad", "New Delhi". Wherever a display-form
// value was interpolated straight into a path we ended up publishing
// `/Ahmedabad/event/...`, a second crawlable URL for a page that already
// exists at `/ahmedabad/event/...`.
//
// Three near-identical implementations of this existed (lib/routes.js,
// lib/sitemap/filters.js, components/common/Breadcrumbs/breadcrumb.utils.js)
// and the two places that actually produced the bad URLs had none. They all
// delegate here now.
export const DEFAULT_CITY = "ahmedabad";

export const toCitySlug = (value, { fallback = DEFAULT_CITY } = {}) => {
  const slug = String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");

  return slug || fallback;
};
